module.exports = __webpack_public_path__ + "static/media/innerOpacityBg.d12beb9b.png";